import { AgentIcon, FactionType } from "~/business";

export const Colors = {
  blue: {
    main: "#3280C7",
    light: "#E1EDF7",
  },
  green: {
    dark: "#025a02",
    main: "#16ae16",
    light: "#469553",
  },
  red: {
    main: "#c41212",
  },
  yellow: {
    dark: "#977b21",
    darker: "rgb(179 143 26)",
    main: "#dec36c",
    light: "rgb(238, 239, 174)",
  },
  common: {
    white: "white",
    black: "black",
  },
  grey: {
    background: "#D9D9D9",
    dark: "#d3d3d3",
    c3: "#c3c3c3",
    e3: "#e3e3e3",
    darkText: "#4e4e4e",
  },
  faction: {
    [FactionType.Emperor]: {
      main: "#5A5953",
      light: "#787772",
      dark: "#464644",
    },
    [FactionType.Guild]: {
      main: "#882121",
      light: "#A73434",
      dark: "#5e0c0c",
    },
    [FactionType.BeneGesserit]: {
      main: "#65366C",
      light: "#A574B1",
      dark: "#542060",
    },
    [FactionType.Fremen]: {
      main: "#2267A8",
      light: "#3887D0",
      dark: "#133d64",
    },
  },
  agentIcon: {
    [AgentIcon.Landsraad]: {
      main: "#126C21",
      dark: "#063c0f",
    },
    [AgentIcon.City]: {
      main: "#2B4D80",
      dark: "#092856",
    },
    [AgentIcon.SpiceTrade]: {
      main: "#C9B364",
      dark: "#93760e",
    },
  },
  players: [
    {
      main: "red",
    },
    {
      main: "blue",
    },
    {
      main: "green",
    },
    {
      main: "yellow",
    },
  ],
  selection: {
    selectable: "green",
    selectableHover: "green",
    selected: "blue",
    selectedHover: "blue",
  },
};
